<template>
  <main>
    <md-card>
      <md-card-header>
        <div class="md-title">アカウント管理</div>
      </md-card-header>

      <div class="md-layout">
        <div class="md-layout-item md-size-20 md-small-size-100"></div>
        <div class="md-layout-item md-size-60 md-small-size-100">
          <form novalidate @submit.prevent="onSubmit">
            <md-card-header v-if="isSuperUser()">
              <div class="md-layout md-alignment-center-space-between">
                <div class="md-title">法人情報</div>
                <md-button v-if="isShowCorporationInfo" class="md-icon-button md-raised"
                           @click="isShowCorporationInfo = false"
                           :disabled="sending">
                  <md-icon>expand_less</md-icon>
                </md-button>
                <md-button v-else class="md-icon-button md-raised" @click="isShowCorporationInfo = true"
                           :disabled="sending">
                  <md-icon>expand_more</md-icon>
                </md-button>
              </div>
              <div v-if="isShowCorporationInfo" class="md-subhead">※変更する際はJON(jon-web_info@jon.co.jp)までご連絡ください。</div>
            </md-card-header>
            <md-card-content v-if="isShowCorporationInfo">
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>本契約日</label>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>{{ (trial.remaining
                      ? datetimeFormat(trial.remaining.signed_at, common.momentConst.japaneseDateFormat)
                      : null) }}</label>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>法人名</label>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>{{ (account.corporation ? account.corporation.name : null) }}</label>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>法人名カナ</label>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>{{ (account.corporation ? account.corporation.kana : null) }}</label>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>郵便番号</label>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>{{ (account.corporation ? postalCodeFormat(account.corporation.postal) : null) }}</label>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>所在地</label>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>
                      {{ account.corporation
                      ? [account.corporation.pref,
                      account.corporation.city,
                      account.corporation.street_name,
                      account.corporation.street_number,
                      ' ',
                      account.corporation.etc].join('')
                      : null }}
                    </label>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>電話番号</label>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>{{ (account.corporation.contacts && account.corporation.contacts[0]) ?
                      account.corporation.contacts[0].tel : null }}</label>
                  </md-field>
                </div>
              </div>
            </md-card-content>
            <md-card-header>
              <div class="md-title">現在のアカウント情報</div>
              <div class="md-subhead">（※変更する際は管理者へお問い合わせください）</div>
            </md-card-header>
            <md-card-content>
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>部門</label>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>{{ (account.group ? account.group.name : null) }}</label>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>権限</label>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>{{ getRoleName() }}</label>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>ユーザー名</label>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>{{ account.name_last }}{{ account.name_first }}</label>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>ユーザーID</label>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>{{ account.username }}</label>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>メールアドレス</label>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>{{ account.email }}</label>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>登記情報提供サービスID</label>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>{{ account.t_service_id }}</label>
                  </md-field>
                </div>
              </div>
            </md-card-content>

            <md-card-header v-if="!sending && !isTrialUser">
              <div class="md-title">シカクマップパスワードの変更</div>
            </md-card-header>
            <md-card-content v-if="!sending && !isTrialUser">
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100"></div>
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('password')">
                    <label>新しいパスワード</label>
                    <md-input v-model="form.password" type="password" required :disabled="sending"></md-input>
                    <span class="md-helper-text">※ 半角英数字をそれぞれ1種類以上含む8文字以上</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('password')">{{ getValidationResponseMessage('password') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.password.required">{{ errors.password.required }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.password.password">{{ errors.password.password }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.password.minLength">{{ errors.password.minLength }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.password.maxLength">{{ errors.password.maxLength }}</span>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter mt-1">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100"></div>
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('passwordConfirm', 'password_confirm')">
                    <label>新しいパスワードの確認</label>
                    <md-input v-model="form.passwordConfirm" type="password" required :disabled="sending"></md-input>
                    <span class="md-helper-text">※ 半角英数字をそれぞれ1種類以上含む8文字以上</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('password_confirm')">{{ getValidationResponseMessage('password_confirm') }}</span>
                    <span class="md-error"
                          v-if="!$v.form.passwordConfirm.sameAs">{{ errors.passwordConfirm.sameAs }}</span>
                  </md-field>
                </div>
              </div>
            </md-card-content>
            <md-card-actions v-if="!sending && !isTrialUser">
              <div class="md-layout md-alignment-center">
                <md-button :disabled="sending" class="md-primary md-raised" type="submit">
                  <md-icon>save</md-icon>
                  更新する
                </md-button>
              </div>
            </md-card-actions>

            <md-divider v-if="isSuperUser() && !sending && !isTrialUser"></md-divider>
            <md-card-header v-if="isSuperUser() && !terminated && !sending && !isTrialUser">
              <div class="md-title">退会の手続き</div>
            </md-card-header>
            <md-card-actions v-if="isSuperUser() && !terminated && !sending && !isTrialUser">
              <div class="md-layout md-alignment-center">
                <router-link :to="{name: 'BackendUserDeactivate'}">
                  <md-button class="md-accent md-raised" :disabled="sending">退会の手続き</md-button>
                </router-link>
              </div>
            </md-card-actions>
          </form>
        </div>
      </div>
    </md-card>
    <md-snackbar :md-active.sync="showSnackBar"
                 :md-duration="snackbarDuration"
                 @md-closed="showSnackBar = false">
      <span>{{ successMessage }}</span>
      <md-button class="md-primary" @click="showSnackBar = false">閉じる</md-button>
    </md-snackbar>
  </main>
</template>

<script>
  import Common                                          from "../../../modules/common";
  import CommonMixin                                     from "../../../mixins/commonMixin";
  import {validationMixin}                               from 'vuelidate'
  import {maxLength, minLength, required, sameAs,}       from 'vuelidate/lib/validators'
  import Validation                                      from "../../../modules/validation";
  import {apiClientWithUserToken as apiClient, apiList,} from '../../../modules/apiClient';
  import axios                                           from 'axios';

  export default {
    name   : "UserSetting",
    mixins : [CommonMixin, validationMixin],
    data() {
      return {
        roles                : [],
        account              : {},
        trial                : {},
        terminated           : null,
        form                 : {
          password       : null,
          passwordConfirm: null,
        },
        errors               : {
          password       : {
            required : Validation.errorMessage(Validation.rules.required, 'password'),
            minLength: Validation.errorMessage(Validation.rules.minLength, 'password', 8),
            maxLength: Validation.errorMessage(Validation.rules.maxLength, 'password', 100),
            password : Validation.errorMessage(Validation.rules.password, 'password'),
          },
          passwordConfirm: {
            sameAs: Validation.errorMessage(Validation.rules.sameAs, 'password'),
          },
        },
        isShowCorporationInfo: false,
        common               : Common,
        isTrialUser          : false,
      };
    },
    validations() {
      return {
        form: {
          password       : {
            required,
            minLength: minLength(8),
            maxLength: maxLength(100),
            password : Validation.password,
          },
          passwordConfirm: {
            sameAs: sameAs('password'),
          },
        },
      };
    },
    mounted() {
      this.getAccountDetail();
    },
    updated() {
      let selectorInvalid = this.$el.querySelector(".md-invalid");
      if (selectorInvalid !== null) {
        this.scrollToSelector(selectorInvalid);
      }
      let selectorFlashError = this.$el.querySelector(".flash-error-message");
      if (selectorFlashError !== null) {
        this.scrollToSelector(selectorFlashError);
      }
    },
    methods: {
      getAccountDetail() {
        this.sending = true;
        axios
          .all([
            apiClient.get(apiList.jon.accounts.auth),
            apiClient.get(apiList.accounts.roles),
            apiClient.get(apiList.accounts.trial),
            apiClient.get(apiList.accounts.status),
            apiClient.get(apiList.terminated),
          ])
          .then(axios.spread((...responses) => {
            const authResponse      = responses[0];
            const roleListResponse  = responses[1];
            const trialResponse     = responses[2];
            const statusResponse    = responses[3];
            const terminatedReponse = responses[4]
            if (this.hasResponseErrors(roleListResponse)
              || this.hasResponseErrors(trialResponse)
              || this.hasResponseErrors(authResponse)
              || this.hasResponseErrors(statusResponse)) {
              return;
            }

            this.roles       = roleListResponse.data.data;
            this.account     = authResponse.data;
            this.trial       = trialResponse.data;
            this.isTrialUser = [Common.trialStatus, Common.trialEndedStatus].includes(statusResponse.data.status);
            this.terminated  = terminatedReponse.data.terminated;
          }))
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending = false;
          });
      },
      onSubmit() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          this.updatePassword();
        } else {
          let selectorInvalid = this.$el.querySelector(".md-invalid");
          if (selectorInvalid !== null) {
            this.scrollToSelector(selectorInvalid);
          }
        }
      },
      updatePassword() {
        this.sending = true;
        apiClient.put(apiList.accounts.updatePassword, {
          password        : this.form.password,
          password_confirm: this.form.passwordConfirm,
        })
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.form.password        = null;
            this.form.passwordConfirm = null;
            this.account              = response.data;
            this.showSnackBar         = true;
            this.successMessage       = Common.messages.account.updatePasswordSuccess;
          })
          .catch(error => {
            this.errorMessages = [Common.messages.account.updatePasswordError];
          })
          .finally(() => {
            this.sending = false;
            this.$v.$reset();
          });
      },
      getRoleName() {
        if (!this.roles) {
          return null;
        }
        const roleId = this.isSuperUser()
          ? Common.roleSuperUser
          : (this.isGroupAdmin() ? Common.roleGroupAdmin : Common.roleNormalUser);
        const role   = this.roles.filter(function (role) {
          return role.id === roleId;
        });
        return role.length > 0 ? role[0].label : null;
      },
    },
  }
</script>

<style lang="scss" scoped>
  tbody .md-table-row td {
    border: none;
  }

  .md-divider {
    margin-top: 160px;
  }

  .mt-1 {
    margin-top: 1em;
  }
</style>
